export default "__VITE_ASSET__0a55911f__"